import React, { FC } from 'react';

import { useIsViewport, Viewports } from '~/hooks/useIsViewport';
import { useIsHomePageRedesignEnabled } from '~/modules/home/useIsHomePageRedesignEnabled';

import DesktopSidebar from './components/DesktopSidebar';
import HomePageV2Sidebar from './components/HomePageV2Sidebar';
import { useMainLayoutSidebarGroups } from './hooks/useMainLayoutSidebarGroups';

type Props = {
  children?: React.ReactNode;
};

const MainLayoutTools: FC<Props> = ({ children }) => {
  const sidebarGroups = useMainLayoutSidebarGroups();
  const isDesktop = useIsViewport(Viewports.EXTRA_SMALL_DESKTOP);
  const isHomePageRedesignEnabled = useIsHomePageRedesignEnabled();

  if (!isDesktop) {
    return <>{children}</>;
  }

  return (
    <DesktopSidebar
      sidebarGroups={sidebarGroups}
      sidebar={isHomePageRedesignEnabled ? <HomePageV2Sidebar /> : undefined}
    >
      {children}
    </DesktopSidebar>
  );
};

export default MainLayoutTools;
